import styles from "./profileInnerEdit.module.scss";

import { Input, Button, Dropdown, Upload, Modal, Slider, Menu, Select } from "antd";
// import { URCheckBox } from "../../../maincomponents/checkbox";
// import { URButton } from '../../../maincomponents/button';
// import { URInput } from '../../../maincomponents/input';
//*import profilepicture from "../../../../styles/images/1a.png";
import profileemptypicuture from "../../../../styles/images/profile_empty_icon.svg";
//import profilestatusicon from "../../../../styles/images/profile-status-icon.svg";
//*import profileuploadpicture from "../../../../styles/images/icon4.png";
// import { StatusTag } from '../../../maincomponents/statusTag';
//*import { StatusTag } from "../../../../shared/widgets/statusTag";
//*import { DownloadOutlined } from '@ant-design/icons';
// import { URInputwithLabel } from '../../../maincomponents/inputwithLable';
import React, { useState } from 'react';
import { URButton } from "../../../../shared/widgets/button";
import { initialStateModel, LoginState, profileDetails } from "../../../../models/model";
import { useSelector } from "react-redux";
import { chatSDK } from "unifiedring-sdk";
import { getCookie, setCookie } from "../../../../base/utils";
//import {contactService} from "../../../../base/contactService/index";
import store from "../../../../context/store/store";
//*import axios from "axios";
import { Types } from "../../../../context/action/action";
import { URInput } from '../../../../shared/widgets/input';
import { config } from "../../../../base/constant";
import axios from "axios";
import { toastInformation } from "../../../../base/callService/common";
//import ProfileInnerLogs from "../profileInnerLogs";
import ImgCrop from "antd-img-crop";
import { TIMEZONE } from '../../../../base/meetingService/timezone';

type ProfileInnerProps = {
  profileData: any;
  userStatus: any;
  mainProgram: Function;
  emergencyAddressDataProps: any;
}
type ProfileInnerStater = {
  isEdit: boolean;
  isSelect: boolean;
  isProfile: boolean;
  beforeLoadImage: any;
  tempImage: any;
  nameError: boolean;
  mobileError: boolean;
  editData: {
    ProfileImage: any;
    profileName: any;
    fullName: any;
    Designation: any;
    Status: any;
    Department: any;
    employeeId: any;
    emailId: any;
    ext: any;
    unifiedRingNumber: any;
    companyNumber: any;
    mobileNo: any;
    internationalNumber: any
    conferanceNumber: any;
    timeZone: any;
    userLanguage: any;
  };
  timeZoneValue: any;
  tempTimeZone: any;
  isUploadValue: any;
  height: any;
  width: any;
  steps: number;
  isRemove: any;
  nativelang: any;
  isStatusSelect: boolean;
}
type settingsState = {
  inputTypePassword: boolean;
  inputTypeNewPassword: boolean;
  inputTypeConfrimPassword: boolean;
  changePassword: boolean;
  isModalVisible: boolean;
  defaultDirectNumber: any;
  allPasswords: {
    password: string;
    newPassword: string;
    confrimPassword: string;
    oldPassword: string;

  }
  emergencyAddressData: {
    buildingName: string;
    streetName: string;
    city: string;
    country: string;
    pinCode: string;
  }
  passwordError: boolean;
  changePasswordtag: boolean;
  confrimpasswordError: boolean;
  newpasswordError: boolean;
  errorText: {
    passwordErrorText: string;
    confrimPasswordErrorText: string;
  }
}
export default function ProfileInnerEdit({ profileData, userStatus, mainProgram, emergencyAddressDataProps }: ProfileInnerProps) {
  const loginDetails: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  let { userdetails } = loginDetails;
  var lastIndex = userdetails.profile_url;
  var fileName = lastIndex.substring(lastIndex.lastIndexOf("/") + 1, lastIndex.length);
  let { isUserStatus }: profileDetails = useSelector((state: any) => state.profileReducer);
  const [ProfileDisplayData, setProfileDisplayData] = useState<ProfileInnerStater>({
    isEdit: false, isSelect: false, isProfile: false, isUploadValue: {}, beforeLoadImage: '', tempImage: "", height: "", steps: 0,
    width: "", isRemove: false, isStatusSelect: false, nativelang: "Global English (en) - Default", nameError: false, mobileError: false,
    timeZoneValue: TIMEZONE, tempTimeZone: TIMEZONE,
    editData: {
      ProfileImage: userdetails.profile_url,
      profileName: profileData?.Firstname,
      fullName: profileData.Surname,
      Designation: profileData?.position ?? "",
      Status: userStatus,
      Department: profileData?.Department,
      employeeId: profileData?.emp_id,
      emailId: profileData?.Email,
      ext: profileData?.Extension_Number,
      unifiedRingNumber: profileData?.Direct_Number,
      companyNumber: profileData?.switch_board_no,
      mobileNo: profileData?.Mobileno,
      conferanceNumber: profileData?.conference_number,
      internationalNumber: profileData?.International_number,
      timeZone: profileData?.Time_zone,
      userLanguage: profileData?.user_language
    }
  });

  const [settingsStateValues, setsettingsStateValues] = useState<settingsState>({
    inputTypePassword: false,
    inputTypeNewPassword: false,
    inputTypeConfrimPassword: false,
    changePassword: false,
    isModalVisible: false,
    defaultDirectNumber: '',
    emergencyAddressData: {
      buildingName: emergencyAddressDataProps.buildingName || "",
      streetName: emergencyAddressDataProps.streetName || "",
      city: emergencyAddressDataProps.city || "",
      country: emergencyAddressDataProps.country || "",
      pinCode: emergencyAddressDataProps.pinCode || ""
    },
    allPasswords: {
      password: "",
      newPassword: "",
      confrimPassword: "",
      oldPassword: profileData?.app_login_pwd
    },
    passwordError: false, changePasswordtag: false,
    newpasswordError: false,
    confrimpasswordError: false,
    errorText: {
      passwordErrorText: "",
      confrimPasswordErrorText: ""
    }
  });
  const updateProfileData = () => {
    let { editData } = ProfileDisplayData;
    if (editData?.profileName?.trim() === "") {
      setProfileDisplayData({ ...ProfileDisplayData, nameError: true });
    } else {
      if (!ProfileDisplayData.isRemove) {
        uploadProfile();
        mainProgram(0);
      } else {
        profileRemove()
        mainProgram(0);
      }

      if (ProfileDisplayData.isStatusSelect) {
        setUserpresenceStatus(ProfileDisplayData.editData.Status);
      }


      if (ProfileDisplayData.isEdit) {
        let updateDetails = {

          company_id: userdetails?.company_id,
          basket_id: profileData?.Basket_id,
          extension_number: editData?.ext,
          firstname: editData?.profileName,
          surname: editData?.fullName,
          designation: profileData?.position ?? "",
          department: editData?.Department,
          email: editData?.emailId,
          mobileno: editData?.mobileNo,
          direct_number: profileData?.Direct_Number,
          recorded_usename_filepath: profileData?.Record_usename_filepath,
          recorded_by: profileData?.Recorded_by,
          recorded_type: profileData?.Recorded_type,
          recorded_greeting: profileData?.Recorded_greeting,
          status: profileData?.Status,
          extn_audio_file: profileData?.extn_audio_file,
          extn_name_audio_file: profileData?.extn_name_audio_file,
          user_language: ProfileDisplayData?.nativelang,
          greeting_language: profileData?.Greeting_Language,
          regional_language: profileData?.Regional_Language,
          home_country_code: profileData?.Home_Country_Code,
          time_zone: editData?.timeZone,
          time_format: profileData?.Time_format,
          role_id: userdetails?.role_id,
          mapwithphone: 1,
          emp_id: editData.employeeId,
          update_type: 1,
          Hubspot_contactid: 132512751,
          Phone_id: "",
          user_type: 0
        };
        //let userInfo: any = getCookie('userinfo');
        const userInfosess: any = sessionStorage.getItem("userinfo");
        let userInfo: any = userInfosess;
        new chatSDK.ChatRestService().updateProfileInfo(updateDetails).then((response: any) => {
          try {
            if (response.statusCode === 200) {
              profileData.Firstname = ProfileDisplayData?.editData?.profileName;
              profileData.Surname = ProfileDisplayData?.editData?.fullName;
              profileData.Department = ProfileDisplayData?.editData?.Department;
              profileData.emp_id = ProfileDisplayData?.editData?.employeeId;
              profileData.Email = ProfileDisplayData?.editData?.emailId;
              profileData.Extension_Number = ProfileDisplayData?.editData?.ext;
              profileData.Mobileno = ProfileDisplayData?.editData?.mobileNo;
              profileData.Time_zone = ProfileDisplayData?.editData?.timeZone;
              profileData.user_language = ProfileDisplayData?.editData?.userLanguage;
              let parse = JSON.parse(userInfo);

              let callerName = `${response.user_details.firstname} ${response.user_details.lastname}`;

              parse.caller_id = callerName;
              // setCookie('userinfo', JSON.stringify(parse), 1);
              sessionStorage.setItem("userinfo", JSON.stringify(parse));
              userdetails.caller_id = callerName;
              store.dispatch({
                type: Types.ADD_LOGIN,
                payload: { userdetails: userdetails }
              });


              store.dispatch({
                type: Types.PROFILE_DETAIL,
                payload: {
                  isprofile: true,
                  profileData: profileData
                }
              });
              mainProgram(0);

              toastInformation("Changes made successfully", "success");
            }
          } catch (err: any) {
            toastInformation("Network Failure", "error");
          }
        });

      }
    }




  };
  const cancelClick = () => {
    mainProgram(0);
  };
  const setUserpresenceStatus = (data: any) => {

    let Statusdata = {

      status_msg: data,
      status_indicator: 0,
      type: 1

    };
    new chatSDK.ChatRestService().updateStatusNote(Statusdata).then((res) => {
      if (res?.statusCode === 200) {

        store.dispatch({
          type: Types.USER_STATUS,
          payload: {
            userStatusData: ProfileDisplayData.editData.Status,
            isUserStatus: isUserStatus

          }
        });

      }


    });


  };
  /**
   * Function used to handle zoom out files in preview page
   */
  const handleZoomOut = () => {
    let height: any = ProfileDisplayData.height;
    let width: any = ProfileDisplayData.width;
    let GFG: any = document.querySelector(".imageZoom");

    if (width === "") {
      width = GFG.clientWidth;
      height = GFG.clientHeight;
    }
    width = width.toString();
    height = height.toString();
    width.replace("px", "");
    height.replace("px", "");
    width = parseInt(width) - 10 + "px";
    height = parseInt(height) - 10 + "px";

    let steps = ProfileDisplayData.steps - 10;
    setProfileDisplayData({ ...ProfileDisplayData, height: height, width: width, steps: steps });

  };

  /**
   * Function used to handle zoom IN files in preview page
   */
  const handleZoomIn = () => {
    let height: any = ProfileDisplayData.height;
    let width: any = ProfileDisplayData.width;
    let GFG: any = document.querySelector(".imageZoom");

    if (width === "") {
      width = GFG.clientWidth;
      height = GFG.clientHeight;
    }
    width = width.toString();
    height = height.toString();
    width.replace("px", "");
    height.replace("px", "");
    width = parseInt(width) + 10 + "px";
    height = parseInt(height) + 10 + "px";
    // this.setState({ height, width });
    let steps = ProfileDisplayData.steps + 10;
    setProfileDisplayData({ ...ProfileDisplayData, height: height, width: width, steps: steps });

  };
  const uploadProfile = async () => {
    let formData = new FormData();
    let nwProfileImage = ProfileDisplayData.isUploadValue;
    //let userInfo: any = getCookie('userinfo');
    const userInfosess: any = sessionStorage.getItem("userinfo");
    let userInfo: any = userInfosess;
    if (ProfileDisplayData.isRemove === false) {
      let token: any = getCookie("ssoToken");
      formData.append("pic", nwProfileImage);
      const url: string = `${config().CHAT_RESTAPI_URL}/upload/profile?type=user`;
      var authkey = {
        "Content-Type": "application/json",
        Authorization: token
      };
      await axios
        .put(url, formData, { headers: authkey })
        .then(async (response: any) => {
          if (response.data.statusCode === 200) {
            let parse = JSON.parse(userInfo);
            parse.profile_url = response.data.files.geturl;
            //setCookie('userinfo', JSON.stringify(parse), 1);
            sessionStorage.setItem("userinfo", JSON.stringify(parse));
            userdetails.profile_url = response.data.files.geturl;
            userdetails.profile_image_thumbnail = response.data.files.geturl;
            store.dispatch({
              type: Types.ADD_LOGIN,
              payload: { userdetails: userdetails }
            });
            setProfileDisplayData({
              ...ProfileDisplayData, isProfile: false, isSelect: false, editData: {
                ...ProfileDisplayData.editData,
                ProfileImage: response.data.files.geturl
              }
            });
            toastInformation("Profile Picture Changed", "success");
          }
        }).catch(function (error: any) {
          toastInformation("Unsupported format", "success");
          console.log("error is", error);
        });
    }
  }
  const profileRemove = async () => {
    let profileImageUrl: any = userdetails.profile_url;
    let token: any = getCookie("ssoToken");
    //let userInfo: any = getCookie('userinfo');
    const userInfosess: any = sessionStorage.getItem("userinfo");
    let userInfo: any = userInfosess;
    let parse = JSON.parse(userInfo);
    const url: string = `${config().CHAT_RESTAPI_URL}/upload/profile`;
    const profilepathempty = profileImageUrl.substring(0, profileImageUrl.lastIndexOf("/"));
    const profileavatar = profilepathempty + '/avatar.png';
    var authkey = {
      "Content-Type": "application/json",
      Authorization: token
    };
    await axios
      .delete(url, { data: { profileImageUrl: profileImageUrl }, headers: authkey })
      .then(async (response: any) => {
        if (response.data.statusCode === 200) {
          parse.profile_url = profileavatar;
          //setCookie('userinfo', JSON.stringify(parse), 1);
          sessionStorage.setItem("userinfo", JSON.stringify(parse));
          userdetails.profile_url = profileavatar;
          userdetails.profile_image_thumbnail = profileavatar;
          store.dispatch({
            type: Types.ADD_LOGIN,
            payload: { userdetails: userdetails }
          });
          setProfileDisplayData({
            ...ProfileDisplayData, isProfile: false, isSelect: false, editData: {
              ...ProfileDisplayData.editData,
              ProfileImage: ""
            }
          });
          toastInformation(config().REMOVEPROFILE, "success");
        }
      }).catch(function (error: any) { console.log("error is", error); });
  }
  const upload = (e: any) => {
    let Base64;
    getBase64(e, (result: any) => {
      Base64 = result;
      setProfileDisplayData({
        ...ProfileDisplayData, isSelect: true, isRemove: false,
        beforeLoadImage: Base64, isUploadValue: e
      });
    });
  };
  const [isModalVisible, setIsModalVisible] = useState(false);

  const saveEditedImage = () => {
    setProfileDisplayData({
      ...ProfileDisplayData, isSelect: true, tempImage: '',
      beforeLoadImage: ProfileDisplayData.tempImage
    });
    setIsModalVisible(false);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
    setProfileDisplayData({ ...ProfileDisplayData, tempImage: "" });
  };

  const handleOnChange = (name: string, e: any) => {
    if (name === "profileName" || name === "fullName") {
      var re = /^[a-zA-Z ]*$/;
      if (re.test(e.target.value) === false) {
        setProfileDisplayData({
          ...ProfileDisplayData,
          isEdit: true, mobileError: true
        });
        return true;
      }
    }
    if (name === "mobileNo") {
      var mob = /^(0|[1-9][0-9]*)$/;
      if (mob.test(e.target.value) === false) {
        setProfileDisplayData({
          ...ProfileDisplayData,
          isEdit: true, mobileError: true
        });
        return true;
      }
    }
    setProfileDisplayData({
      ...ProfileDisplayData,
      isEdit: true, nameError: false, mobileError: false, editData: {
        ...ProfileDisplayData.editData, [name]: e.target.value
      }
    });

  };

  // const isEmpty = (value: any) =>
  //   value === undefined ||
  // value === null ||
  // (typeof value === "object" && Object.keys(value).length === 0) ||
  // (typeof value === "string" && value.trim().length === 0);

  const getBase64 = (file: any, cb: any) => {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      cb(reader.result);
    };
    reader.onerror = (error) => {};
  };
  const setStatus = (val: any) => {

    setProfileDisplayData({
      ...ProfileDisplayData, isStatusSelect: true, editData: {
        ...ProfileDisplayData.editData, Status: val.key
      }
    });
  };
  const setNativeLang = (val: any) => {
    setProfileDisplayData({ ...ProfileDisplayData, isEdit: true, nativelang: val.key });
  }
  const outPutStatusSelection = (
    <Menu className="statusDropDown statuslists" onClick={setStatus}>
      <Menu.Item className="active" key={"Working remotely"}>
        <span className="icon_Home "></span> Working remotely</Menu.Item>
      <Menu.Item key={'In a Meeting'}><span className="icon_Calendar"></span> In a Meeting</Menu.Item>
      <Menu.Item key={'Travelling'}><span className="icon_Van"></span> Travelling</Menu.Item>
      <Menu.Item key={'Sick'}><span className="icon_sad"></span> Sick</Menu.Item>
      <Menu.Item key={'On Vacation'}><span className="icon_Natural"></span> On Vacation</Menu.Item>
    </Menu>
  );

  const nativelaug = (
    <div className={`nativelaug ${styles.autoTranslateLangs}`}>
      {/* <span className={styles.topsecTxtTitle}>Record Spoken language</span> */}
      <div className={styles.searchBox}><URInput placeHolder='Search'
        className='searchBoxlanglist' onChange={() => { }} />
      </div>
      <Menu className="statusDropDown nativeLangSel scroller" onClick={setNativeLang}>
        <Menu.Item key={'Global English (en) - Default'}><span className="icon_tick ltick"></span>
          Global English (en) - Default
        </Menu.Item>
        <Menu.Item key={'Spanish (es)'}><span className="icon_tick"></span>
          Spanish (es)
        </Menu.Item>
        {/*  <Menu.Item key={'Spanish (es)'}><span className="icon_tick"></span>
          <span className="laugname">Spanish (es)</span>
        </Menu.Item> */}
        <Menu.Item key={'French (fr)'} className="active"><span className="icon_tick"></span>
          French (fr)
        </Menu.Item>
        <Menu.Item key={'Portuguese (pt)'}><span className="icon_tick"></span>
          Portuguese (pt)
        </Menu.Item>
        <Menu.Item key={'Japanese (ja)'}><span className="icon_tick"></span>
          Japanese (ja)</Menu.Item>
        <Menu.Item key={'Korean (ko)'}><span className="icon_tick"></span> Korean (ko)</Menu.Item>
        {/*     <Menu.Item key={'Spanish (es)'}><span className="icon_tick"></span>
          <span className="laugname">Spanish (es)</span>
        </Menu.Item>
        <Menu.Item key={'TFrench (fr)'}><span className="icon_tick"></span>
          <span className="laugname">French (fr)</span>
        </Menu.Item>
        <Menu.Item key={'Portuguese (pt)'}><span className="icon_tick"></span>
          <span className="laugname">Portuguese (pt)</span>
        </Menu.Item> 
        {/* <Menu.Item key={'Portuguese (pt)'}><span className="icon_tick"></span>Portuguese (pt)</Menu.Item>
        <Menu.Item key={'Japanese (ja)'}><span className="icon_tick"></span>Japanese (ja)</Menu.Item>
        <Menu.Item key={'Korean (ko)'}><span className="icon_tick"></span>Korean (ko)</Menu.Item>
        <Menu.Item key={'Dutch (nl)'}><span className="icon_tick"></span>Dutch (nl)</Menu.Item> */}
      </Menu>
    </div>
  );
  const timeZoneOnchange = (value: any) => {
    setProfileDisplayData({ ...ProfileDisplayData, isEdit: true, editData: { ...ProfileDisplayData?.editData, timeZone: value }, timeZoneValue: ProfileDisplayData?.tempTimeZone });
  };
  const searchInput = (e: string) => {
    let searchText = e.toLowerCase();
    const filterZone: Array<any> = TIMEZONE
      .filter((value: any) => value.name.toLowerCase().includes(searchText));
    setProfileDisplayData({ ...ProfileDisplayData, timeZoneValue: filterZone });
  };
  const selectDropDown = () => {
    let element: HTMLElement | any = document.getElementById("meetSchedule") || null;

    if (element != null) {
      if (element.hasAttribute('scroll') === true) {
        element.removeAttribute("scroll");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "none";
        element.style["overflow-y"] = "overlay";

      }
      else {
        element.setAttribute("scroll", "no");
        let hoverdiv: HTMLElement | any = document.getElementById("frezsec") || null;

        if (hoverdiv) hoverdiv.style["display"] = "block";
        element.style["overflow"] = "hidden";
      }
    };

  };
  const editEmergencyAddress = () => {
    setsettingsStateValues({
      ...settingsStateValues, isModalVisible: true
    });
  };
  const emergencyCancel = () => {
    let emergencyAddressData: any = {
      buildingName: emergencyAddressDataProps.buildingName || "",
      streetName: emergencyAddressDataProps.streetName || "",
      city: emergencyAddressDataProps.city || "",
      country: emergencyAddressDataProps.country || "",
      pinCode: emergencyAddressDataProps.pinCode || ""
    };

    setsettingsStateValues({ ...settingsStateValues, isModalVisible: false, emergencyAddressData: emergencyAddressData });

  }
  let { buildingName, streetName, city, country, pinCode } = settingsStateValues.emergencyAddressData;
  const UpdateemergencyAddress = () => {
    let emergencyDetails = {
      address_line_1: buildingName,
      address_line_2: streetName,
      city: city,
      post_code: pinCode,
      country: country
    };
    new chatSDK.ChatRestService().updateEmergDetails(emergencyDetails).then((response: any) => {
      if (response.statusCode === 200) {
        store.dispatch({
          type: Types.EMERGENCY_ADDRESS,
          payload: {
            emergencyAddressData: settingsStateValues.emergencyAddressData,
            isemergencyAddressData: true
          }
        });
        setsettingsStateValues({ ...settingsStateValues, isModalVisible: false });
        toastInformation("Emergency address updated", "success");
      }
    });
  };
  const countrySelect = (val: any) => {
    setsettingsStateValues({
      ...settingsStateValues, emergencyAddressData: {
        ...settingsStateValues.emergencyAddressData, country: val.key
      }
    });
  };

  const changePasswordlink = () => {

    let oldPasswordValidation = {
      currentPassword: settingsStateValues.allPasswords.password
    };

    new chatSDK.ChatRestService().currentPassword(oldPasswordValidation).then((res) => {

      if (res?.statusCode === 200) {
        if (!res.credential) {
          setsettingsStateValues({
            ...settingsStateValues, passwordError: true, changePassword: false,
            errorText: {
              ...settingsStateValues.errorText, passwordErrorText: `Enter current Password`
            }
          });
        }
        else {
          setsettingsStateValues({ ...settingsStateValues, changePassword: true, passwordError: false, changePasswordtag: true });
        }
      }
    });
  };

  const PasswordValidation = () => {
    if (settingsStateValues.allPasswords.newPassword !== settingsStateValues.allPasswords.confrimPassword
      || settingsStateValues.allPasswords.newPassword === "" || settingsStateValues.allPasswords.confrimPassword === "") {
      setsettingsStateValues({
        ...settingsStateValues, confrimpasswordError: true,
        errorText: {
          ...settingsStateValues.errorText, confrimPasswordErrorText: "Those passwords didn't match"
        }
      });
    } else {
      setsettingsStateValues({ ...settingsStateValues, confrimpasswordError: false });
      let passwordData = {
        login_password: settingsStateValues.allPasswords.newPassword
      };
      new chatSDK.ChatRestService().updatePassword(passwordData).then((res) => {
        if (res.statusCode === 200) {
          setsettingsStateValues({
            ...settingsStateValues,
            allPasswords: {
              ...settingsStateValues.allPasswords,
              password: "",
              newPassword: "",
              confrimPassword: ""
            }
          });
          toastInformation("Password changed successfully", "success");
          localStorage.clear();
          window.location.href = '/login';
          sessionStorage.clear();
        }
      });
    }
  };
  const getpassword = (e: any) => {
    setsettingsStateValues({
      ...settingsStateValues,
      allPasswords: { ...settingsStateValues.allPasswords, password: e.target.value }, passwordError: false,
      errorText: {
        ...settingsStateValues.errorText, passwordErrorText: ""
      }
    });
  };

  const getnewpassword = (e: any) => {
    setsettingsStateValues({
      ...settingsStateValues,
      allPasswords: { ...settingsStateValues.allPasswords, newPassword: e.target.value },
      newpasswordError: false
    });
  };

  const getconfrimpassword = (e: any) => {
    setsettingsStateValues({
      ...settingsStateValues,
      allPasswords: { ...settingsStateValues.allPasswords, confrimPassword: e.target.value },
      confrimpasswordError: false,
      errorText: {
        ...settingsStateValues.errorText, confrimPasswordErrorText: ""
      }
    });
  };
  const Country = (
    <Menu onClick={countrySelect}>
      <Menu.Item key={"India"}>India</Menu.Item>
      <Menu.Item key={"UK"}>UK</Menu.Item>
    </Menu>
  );
  let emergencyAdd: any = buildingName + (buildingName !== "" ? "," : "") + streetName + (streetName !== "" ? "," : "") + city + (city !== "" ? "," : "") + country + (country !== "" ? "," : "") + pinCode

  return (
    <>
      <div className={styles.profileInnerTopSection}>
        <div className={styles.profileInnerTopHeader}>
          <div className={styles.profileInnerTopLeft}>
            <h3>Edit Details</h3>
            <div className={styles.profileTitle}>This is what others will see on your profile.</div>
          </div>
        </div>
      </div>

      <div className={styles.profileBasicInformation}>
        <div className={styles.profileBasicTitle}>Basic Information</div>
        <div className={styles.profileInformationForm}>
          <div className={styles.editInformationImageRow}>
            <div className={styles.editFormLeftpic}>Profile Picture</div>
            <div className={styles.editFormRight}><div className={styles.editEmptyPicture}>
              <img className={styles.editpicture}
                src={ProfileDisplayData.editData.ProfileImage && !ProfileDisplayData.isSelect ?
                  ProfileDisplayData.editData.ProfileImage : ProfileDisplayData.beforeLoadImage
                    || ProfileDisplayData.isSelect ?
                    ProfileDisplayData.beforeLoadImage : profileemptypicuture} alt="" /></div> </div>
            {/*<div className={styles.editFormRight}><div className={styles.editEmptyPicture}>
            <img className={styles.editpicture} src={profileemptypicuture} alt=""/></div></div>*/}
            <div className={userdetails.profile_url ? `${styles.editProfileButton} ${styles.padTopNone}`
              : `${styles.editProfileButton}`}>
              {/* <ImgCrop 
                onModalOk={upload} 
                modalTitle="Upload Image"
                modalCancel=""
                modalOk="Upload" 
                beforeCrop = {(e:any)=> {console.log("***********",e)}}
                onUploadFail= {(e)=>{console.log('on upload fail',e)}}
                onModalCancel={handleCancel}  modalClassName="customPopup  uploadpopupbtn">
                <Upload>
                  <Button type="primary" shape="round" className={`${styles.editUploadButton} ${styles.changetxt}`}>
                    <span className="icon_profileupload"></span>
                    src={userdetails.profile_url?userdetails.profile_url:profilepicture}
                    <span className={styles.editUploadText}>Change Photos</span></Button>
                </Upload>
              </ImgCrop> */}
 
                 <ImgCrop 
                  // rotate
                  // beforeCrop = {(e:any)=> {console.log("***********",e)}}
                  // onUploadFail= {(e)=>{console.log('on upload fail',e)}}
                  modalTitle="Upload Image"
                  modalCancel=""
                  modalOk="Upload" 
                  onModalCancel={handleCancel}
                  onModalOk={upload}
                  modalClassName="customPopup  uploadpopupbtn"
                 >
                <Upload>
                <Button type="primary" shape="round" className={`${styles.editUploadButton} ${styles.changetxt}`}>
                    {/* <span className="icon_profileupload"></span>
                    src={userdetails.profile_url?userdetails.profile_url:profilepicture} */}
                    <span className={styles.editUploadText}>Change Photos</span></Button>
                </Upload>
              </ImgCrop>
              {/* <p className={styles.imageDescriptiion}>
                Supports File Formats : (JPG, JPEG, PNG) less than 5MB </p> */}

              {/* <ImgCrop grid rotate>
                <Upload
                  action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                  listType="picture-card"
                  fileList={fileList}
                  onChange={onChange}
                  onPreview={onPreview}
                >
                  {fileList.length < 3 && '+ Upload'}
                </Upload>
              </ImgCrop> */}
              {/* { ProfileDisplayData?.beforeLoadImage.length >0
               && <div><img src={profilestatusicon} onClick={showModal} alt=""/>
              
               </div>} */}
              {/* {userdetails.profile_url && fileName !== 'avatar.png' &&
                <Button type="primary" shape="round" onClick={() => {
                  setProfileDisplayData({
                    ...ProfileDisplayData, isSelect: true, tempImage: '', isProfile: false,
                    beforeLoadImage: profileemptypicuture, isRemove: true, editData: {
                      ...ProfileDisplayData.editData,
                      ProfileImage: profileemptypicuture
                    }
                  });
                }}
                  className={styles.editRemoveButton}>Remove</Button>} */}
              {/* <p className={styles.RemoveDescriptiion}>
                {fileName !== 'avatar.png' ? fileName : ''} </p> */}
            </div>
          </div>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Profile Name</div>
            <div className={styles.editFormRightName}>
              <Input
                value={ProfileDisplayData.editData.profileName}
                className={`${styles.editInputBlack} ${ProfileDisplayData?.nameError ? "errorInput" : ""}`}
                onChange={(e: any) => handleOnChange('profileName', e)}
              />
              {/*<Input defaultValue="UI Designer" className={styles.editInputGray}/>*/}
            </div>

          </div>

          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Status</div>
            <div className={styles.editFormRightName}>
              <Dropdown overlay={outPutStatusSelection} placement="bottomRight" trigger={['click']}>
                <div className={styles.editStatus}>
                  <div><span className={ProfileDisplayData.editData.Status === "In a Meeting" ?
                    `icon_Calendar ${styles.Tickiconpop}` : ProfileDisplayData.editData.Status === "Travelling" ?
                      `icon_Van ${styles.Tickiconpop}` : ProfileDisplayData.editData.Status === "Sick" ?
                        `icon_sad ${styles.Tickiconpop}` : ProfileDisplayData.editData.Status === "On Vacation" ?
                          `icon_Natural ${styles.Tickiconpop}` : `icon_Home ${styles.Tickiconpop}`}>
                  </span> <span>{ProfileDisplayData.editData.Status}</span></div>
                  <span className="icon_downarrow2"></span>
                </div>
              </Dropdown>
            </div>
          </div>

          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Password</div>
            <div className={styles.editFormRightName}>
            <div className={styles.confrmInput}>
              <input type={settingsStateValues.inputTypePassword ? "text" : "password"}
                value={settingsStateValues.allPasswords.password}
                className={styles.formControl} placeholder="Password" onChange={(e: any) => getpassword(e)} maxLength={32} />
              <span
                onClick={() => setsettingsStateValues({
                  ...settingsStateValues,
                  inputTypePassword: !settingsStateValues.inputTypePassword
                })}
                className={settingsStateValues.inputTypePassword ? `icon_Viewpassword ${styles.iconEyes}` :
                  `icon_Password ${styles.iconEyes}`
                }>

              </span></div>
              {settingsStateValues.passwordError &&
                <p className={styles.errorText}><span className="icon_info"></span>
                  {settingsStateValues.errorText.passwordErrorText}</p>
              }

              <p className={`${styles.five} ${styles.changPassTxt}`}>
                {/* <Link to="/" >Change Password.</Link> */}
                {
                  !settingsStateValues.changePasswordtag && <a href="#/" onClick={changePasswordlink}>Change Password...</a>}
              </p>


              {settingsStateValues.changePassword &&
                !settingsStateValues.passwordError && <div className={``} >
                  <div>
                    <div className={styles.confrmInput}>
                      <input type={settingsStateValues.inputTypeNewPassword ? "text" : "password"}
                        className={styles.formControl} placeholder="New Password"
                        value={settingsStateValues.allPasswords.newPassword}
                        onChange={(e: any) => getnewpassword(e)} />
                      <span
                        onClick={() => setsettingsStateValues({
                          ...settingsStateValues,
                          inputTypeNewPassword: !settingsStateValues.inputTypeNewPassword
                        })}
                        className={settingsStateValues.inputTypeNewPassword ? `icon_Viewpassword ${styles.iconEyes}` :
                          `icon_Password ${styles.iconEyes}`
                        }></span>
                    </div>
                    <div className={styles.confrmInput}>
                      <input type={settingsStateValues.inputTypeConfrimPassword ? "text" : "password"}
                        className={styles.formControl} placeholder="Confirm New Password"
                        value={settingsStateValues.allPasswords.confrimPassword}
                        onChange={(e: any) => getconfrimpassword(e)} />
                      <span
                        onClick={() => setsettingsStateValues({
                          ...settingsStateValues,
                          inputTypeConfrimPassword: !settingsStateValues.inputTypeConfrimPassword
                        })}
                        className={settingsStateValues.inputTypeConfrimPassword ? `icon_Viewpassword ${styles.iconEyes}` :
                          `icon_Password ${styles.iconEyes}`
                        }>

                      </span>
                      {settingsStateValues.confrimpasswordError &&
                        <p className={styles.errorText}><span className="icon_info"></span>
                          {settingsStateValues.errorText.confrimPasswordErrorText}</p>
                      }
                    </div>

                    <div className={styles.confrmbtn}>
                      <URButton className='urButton buttonWhite buttonSm'
                        onClick={() => setsettingsStateValues({
                          ...settingsStateValues, passwordError: false,
                          changePasswordtag: false, changePassword: false

                        })} name='Cancel' />
                      <URButton className='urButton buttonBlue buttonSm' onClick={PasswordValidation} name='Update' />
                      {/* <URButton className={styles.chatcancelbtn} name='Cancel' />
                    <URButton className={styles.chatSharebtn} name='Update' /> */}
                    </div>
                  </div>
                </div>}
            </div>
          </div>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Time zone</div>
            <div className={styles.editFormRightName}>
              <Select
                style={{ width: '100%' }}
                value={ProfileDisplayData?.editData?.timeZone === "2" ? "(GMT+05:30) India Standard Time" : ProfileDisplayData?.editData?.timeZone}
                placeholder="Select timezone"
                onChange={timeZoneOnchange}
                filterOption={false}
                showSearch={true}
                onDropdownVisibleChange={selectDropDown}
                className="selTimezone cusSelDrp"
                dropdownClassName='customSelectdrp'
                onSearch={(e: string) => searchInput(e)}>
                {
                  ProfileDisplayData?.timeZoneValue.map((d: any) =>

                    <option value={d.name}
                      key={d.id}>{`${d.name}`}</option>)
                }
              </Select>
            </div>
          </div>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Native Language</div>
            {/* <div className={styles.editFormRightName}>
              <Dropdown overlay={nativelaug}  placement="bottomRight" trigger={['click']}>
                <div className={`${styles.timezone} ${styles.editStatus} ${styles.nativelaug}`}>
                  <div><span>Global English (en) - Default</span></div>
                  <span className="icon_downarrow2"></span>
                </div>
              </Dropdown>
              <p className={styles.nativetag}>Set your Speaking language for calls & video meeting</p>
            </div> */}
            <div className={styles.editFormRightName}>
              <div className={styles.shareSelect}>
                <Dropdown overlay={nativelaug} placement="bottomRight" trigger={['click']}>
                  <div className={`${styles.timezone} ${styles.editStatus} ${styles.nativelaug}`}>
                    <div className={styles.langSelSec}>
                      <span>{ProfileDisplayData.nativelang}</span>
                      <span className="icon_downarrow2" ></span>
                    </div>

                  </div>
                </Dropdown>
                <p className={styles.nativetag}>Set your Speaking language for calls & video meeting</p>
              </div>
            </div>
          </div>
        </div>

        <div className={styles.profilePersonalTitle}>Personal Information</div>
        <div className={styles.profileInformationForm}>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Last Name</div>
            <div className={styles.editFormRightName}>
              <Input value={ProfileDisplayData.editData.fullName} className={styles.editInputBlack}
                onChange={(e: any) => handleOnChange('fullName', e)}
              />
            </div>
          </div>

          {/* <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Designation</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.Designation} className={styles.editInputBlack}
                onChange={(e)=> setProfileDisplayData({...ProfileDisplayData,
                  isEdit:true,editData:{
                    ...ProfileDisplayData.editData,Designation:e.target.value
                  }})}/>
             
            </div>
          </div> */}

          
    <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Designation</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.ext
                && ProfileDisplayData.editData.Designation} className={styles.editInputBlack}
                disabled />
            </div>
          </div>

          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Department</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.Department
                ? ProfileDisplayData.editData.Department : "--"} className={styles.editInputBlack}
                onChange={(e: any) => handleOnChange('Department', e)}
              />
            </div>
          </div>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Employee ID</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.employeeId
                ? ProfileDisplayData.editData.employeeId : "--"} className={styles.editInputBlack}
                onChange={(e: any) => handleOnChange('employeeId', e)}
                disabled />
            </div>
          </div>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Email Address</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.emailId
                && ProfileDisplayData.editData.emailId} className={styles.editInputBlack}
                onChange={(e: any) => handleOnChange('emailId', e)}
                disabled />
            </div>
          </div>
          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Extension</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.ext
                && ProfileDisplayData.editData.ext} className={styles.editInputBlack}
                onChange={(e: any) => handleOnChange('ext', e)}
                disabled />
            </div>
          </div>
          {profileData?.Direct_Number && <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>My Worktual Number</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.unifiedRingNumber} className={styles.editInputBlack} disabled />
            </div>
          </div>}
          {profileData?.switch_board_no && <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Company Number</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.companyNumber}
                className={styles.editInputBlack} disabled />
            </div>
          </div>}
          {profileData?.conference_number && <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Conference Number</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.conferanceNumber}
                className={styles.editInputBlack} disabled />
            </div>
          </div>}
          {profileData?.Mobileno && <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Mobile Number</div>
            <div className={styles.editFormRightName}>
              <Input
                className={`${styles.editInputBlack} ${ProfileDisplayData?.mobileError ? "errorInput" : ""}`}
                defaultValue={ProfileDisplayData.editData.mobileNo}
                onChange={(e: any) => handleOnChange('mobileNo', e)}
              />
            </div>
          </div>}
          {profileData?.International_number && <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>International Number</div>
            <div className={styles.editFormRightName}>
              <Input defaultValue={ProfileDisplayData.editData.internationalNumber} disabled className={styles.editInputBlack} />
            </div>
          </div>}

          <div className={styles.editInformationRow}>
            <div className={styles.editFormLeft}>Emergency Address</div>
            <div className={styles.editFormRightName}>
              <div className={styles.addressInput}>
                <input type="text" className={styles.formControl}
                  value={emergencyAdd}
                  placeholder="Add Your Address" />
                {/* ${buildingName}, ${streetName}, ${city}, ${country}, ${pinCode} */}
                <div className={styles.editBtn}>
                  <span className={styles.linkText} onClick={editEmergencyAddress}>Edit</span>
                  {/* <URButton className='urButton buttonBlue buttonSm' name='Edit' onClick={editEmergencyAddress} /> */}
                </div>
              </div>
              <p className={`${styles.changPassTxt}`}>
                <span className={styles.direcrNo}>Edit physical location address used for public and emergency calls
                </span></p>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.profileFooter}>
        <URButton
          className='urButton buttonWhite buttonSm' name='Cancel' onClick={cancelClick} />
        <span className={styles.emptyspacecenter}></span>
        <URButton className='urButton buttonBlue buttonSm' onClick={updateProfileData} name='Save' />
        {/*         <ProfileInnerLogs/> */}
      </div>
      <Modal title="Crop your Photo"
        centered visible={isModalVisible}
        onOk={saveEditedImage} onCancel={handleCancel}
        cancelText="Cancel" okText={!ProfileDisplayData.editData.ProfileImage ? "Save" : "Crop"}
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }}
        className="customPopup edituploadpicture" >
        <div className={styles.editPopupPicture}>

          <img className={"imageZoom"}
            src={ProfileDisplayData?.tempImage} alt=""
            style={{ width: ProfileDisplayData.width, height: ProfileDisplayData.height }}
          /></div>
        <div className={`customaudioplaySound ${styles.audioplaySound}`}>
          <span className="icon_Preview-minus" onClick={handleZoomOut}></span>
          <div><Slider style={{ width: "90px" }} value={ProfileDisplayData.steps}
          /></div>
          <span className="icon_Preview-plus" onClick={handleZoomIn}></span>
        </div>
      </Modal>
      <Modal visible={settingsStateValues.isModalVisible} title="Emergency Address"
        centered
        onOk={UpdateemergencyAddress}
        onCancel={emergencyCancel}
        cancelText="Cancel"
        okText="Update"
        maskClosable={false}
        cancelButtonProps={{ className: 'urButton buttonWhite' }}
        okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup editFormDetails">
        <div className="formModalSeccon">
          <div className="rowFlex alignItemCenter">
            <div className="twelve marbtmmin">
              <label className="colformLabel">Building Name / Flat No</label>
              <input type="text" className="formControl" placeholder="Enter the Building Name"
                value={settingsStateValues.emergencyAddressData.buildingName}
                onChange={(e: any) => setsettingsStateValues({
                  ...settingsStateValues, emergencyAddressData: {
                    ...settingsStateValues.emergencyAddressData, buildingName: e.target.value
                  }
                })}
              />
            </div>
            <div className="twelve marbtmmin">
              <label className="colformLabel">Street</label>
              <input type="text" className="formControl" placeholder="Enter the Street Name"
                value={settingsStateValues.emergencyAddressData.streetName}
                onChange={(e: any) => setsettingsStateValues({
                  ...settingsStateValues, emergencyAddressData: {
                    ...settingsStateValues.emergencyAddressData, streetName: e.target.value
                  }
                })}
              />
            </div>
            <div className="twelve marbtmmin">
              <label className="colformLabel">City</label>
              <input type="text" className="formControl" placeholder="Enter the city"
                value={settingsStateValues.emergencyAddressData.city}
                onChange={(e: any) => setsettingsStateValues({
                  ...settingsStateValues, emergencyAddressData: {
                    ...settingsStateValues.emergencyAddressData, city: e.target.value
                  }
                })}
              />
            </div>
            {/* <div className="twelve marbtmmin">
              <label className="colformLabel">State</label>
              <Dropdown overlay={state} placement="bottomRight" trigger={['click']}>
                <div className="langSelSecmodal">
                  <span>Select State</span>
                  <span className="icon_downarrow2"></span>
                </div>
              </Dropdown>
            </div> */}
            <div className="twelve marbtmmin">
              <label className="colformLabel">Zip code</label>
              <input type="text" className="formControl" placeholder="Enter the Zip code"
                value={settingsStateValues.emergencyAddressData.pinCode}
                onChange={(e: any) => setsettingsStateValues({
                  ...settingsStateValues, emergencyAddressData: {
                    ...settingsStateValues.emergencyAddressData, pinCode: e.target.value
                  }
                })}
              />
            </div>
            <div className="twelve ">
              <label className="colformLabel">Country</label>
              <Dropdown overlay={Country} placement="bottomRight" trigger={['click']}>
                <div className="langSelSecmodal">
                  <span>{settingsStateValues.emergencyAddressData.country ?
                    settingsStateValues.emergencyAddressData.country : `Select Country`}</span>
                  <span className="icon_downarrow2"></span>
                </div>
              </Dropdown>
            </div>
          </div>
        </div>
      </Modal>

      {/*  {ProfileDisplayData && < ProfileInnerLogs profileData={ProfileDisplayData} />} */}
    </>
  );
};
